module.exports = __webpack_public_path__ + "img/signal-logo.fc99a29f.svg";